import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import {
    setNextModule,
    togglePinDialog,
} from 'store/actions/otherModuleAction.action'
import { ENextModule } from 'store/reducers/otherModuleAction.reducer'
import { useAppSelector } from 'store/useStoreHook'

function usePinDialog() {
    const dispatch = useDispatch()
    const pinCode = useAppSelector((s) => s.otherModuleAction.pin)

    const open = useAppSelector(
        (state) => state.otherModuleAction.openPinDialog,
    )
    const nextModule = useAppSelector(
        (state) => state.otherModuleAction.nextModule,
    )
    const togglePinDialogDispatch = useCallback(
        (open: boolean, nextModule?: ENextModule) => {
            dispatch(togglePinDialog(open))
            dispatch(setNextModule({ module: nextModule }))
        },
        [dispatch],
    )
    return {
        togglePinDialogDispatch,
        nextModule,
        open,
        pinCode,
    }
}

export default usePinDialog
